// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__1Wt3K","switchToDesktop":"App_switchToDesktop__sXptw","toastContainer":"App_toastContainer__IoUJm","totalStaked":"App_totalStaked__33GfK"};